<template>
  <div>
    <p class="title">{{seatList.find(item => item.type === seatSetting.seatStatus).name}}</p>
    <el-row>
      <el-col :span="16">
        <el-form-item :label="$locale('setting.pay.nameshow')">
          <el-input v-model="seatSetting.decorationName" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item :label="$locale('rules.alertMessage')" prop="warningMsg">
          <el-row
            class="alertMessage"
            :gutter="20"
            v-for="(item, idx) in seatSetting.warningMsg"
            :key="idx">
            <el-col :span="8">
              <el-select
                :placeholder="$locale('form.plsSelectPlatform')"
                v-model="item.deviceType"
              >
                <el-option
                  v-for="item in deviceList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                  :disabled="isPlatformDisabled(item.value, idx)"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="10">
              <el-input
                :placeholder="$locale('form.plsEnterMsg')"
                v-model="item.message"
              />
            </el-col>
            <el-col :span="6">
              <div class="btns">
                <el-button class="delete" @click="setAlert('remove', idx)">{{$locale("global.delete")}}</el-button>
                <el-button
                  v-if="idx === seatSetting.warningMsg.length - 1 && seatSetting.warningMsg.length < 4"
                  class="add"
                  @click="() => setAlert()"
                >{{$locale("theatre.seatSettingAdd")}}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { seatList, deviceList } from "@/assets/js/commonList";
export default {
  data() {
    return {
      seatList,
      deviceList,
    };
  },
  props: {
    seatSetting: {
      type: Object,
      default: () => {}
    },
  },
  methods: {
    setAlert(type = "add", idx) {
      const alertMessages = this.seatSetting.warningMsg;
      if (type === "add" && alertMessages.length < 4) {
        this.seatSetting.warningMsg = [...alertMessages, {
          message: "",
          deviceType: ""
        }];
      } else if (alertMessages.length > 1) {
        alertMessages.splice(idx, 1);
      }
    },
    isPlatformDisabled(platformValue, currentIdx) {
      return this.seatSetting.warningMsg.some((msg, idx) => idx !== currentIdx && msg.deviceType === platformValue);
    },
  },
  watch: {
    seatSetting(oldVal, newVal) {
      console.log(newVal);
      // const isError = newVal.warningMsg.find(item => item.message && !item.deviceType);
      // if (isError) {
      //   this.$message({
      //     message: "请输入deviceType",
      //     type: "warning",
      //   });
      // }
    }
  }
};
</script>
<style scoped lang="scss">
  .alertMessage {
    margin-bottom: 15px;
  }
  p {
    margin: 0;
    padding: 0;
  }
  .title {
    font-size: 16px;
    font-weight: 700;
    color: #181818;
    margin-bottom: 15px;
  }
  .btns {
    display: flex;
    .el-button {
      height: 50px;
      border-radius: 3px;
      color: #181818;
      font-size: 16px;
      font-weight: 300;
      &.delete {
        width: 120px;
        background-color: #E14C4C;
      }
      &.add {
        width: 171px;
        border: 1px solid #DDD;
        background-color: #F9DA49;
      }
    }
  }
</style>